// extracted by mini-css-extract-plugin
module.exports = {"DEFAULT-CANCELLED":"table_DEFAULT-CANCELLED__E76Sd","DEFAULT":"table_DEFAULT__2U5Um"};